import { getMoment } from "@/utils/datetime.js";
import db from "@/components/firebaseInit";

const keysOfOwnerToCopyToTimecard = {
    owner_id: "id",
    owner_name: "name",
    owner_team: "team_name",
    owner_user_type: "user_type",
    owner_work_type: "work_type"
};

export const newWorkingHour = {
    office: {
        start: null,
        end: null,
        type: "出社",
        reasonsForEditStart: "",
        reasonsForEditEnd: "",
        isEditWorktime: false,
    },
    home: {
        start: null,
        end: null,
        type: "在宅",
        reasonsForEditStart: "",
        reasonsForEditEnd: "",
        isEditWorktime: false,
    }
};

const response = { status: "", message: "", data: {} }
const moment = getMoment()
export async function startWork(user, calendarDate, workType) {
    const timecard = await getTimecard(user, calendarDate)
    saveStartTime(timecard, workType)
    const result = await saveTimecard(timecard, user)

    if (result) {
        response.status = "ok"
        response.data = timecard
    } else {
        response.status = "error"
        response.message = "Error was occured While adding the timecard to the DB."
    }
    return response

}
export async function endWork(user, calendarDate) {
    const timecard = await getTimecard(user, calendarDate)
    saveEndTime(timecard)
    const result = await saveTimecard(timecard, user)

    if (result) {
        response.status = "ok"
        response.data = timecard
    } else {
        response.status = "error"
        response.message = "Error was occured While adding the timecard to the DB."
    }
    return response

}
function saveStartTime(timecard, workType) {
    const workingHour = createWorkingHour(workType)
    workingHour.start = getCurrentHoursWithLateNight() * 3600 + moment().minute() * 60;
    timecard.working_hours.push(workingHour)
    timecard.start = timecard.working_hours[0].start
}
function saveEndTime(timecard) {
    if (!timecard.working_hours || timecard.working_hours.length == 0) {
        timecard.working_hours.push(createWorkingHour("出社"))
    }
    timecard.working_hours = timecard.working_hours.sort((a, b) => {
        if (a.start < b.start) return -1
        if (a.start > b.start) return 1
        return 0
    })
    const endIndex = timecard.working_hours.length - 1
    timecard.working_hours[endIndex].end = getCurrentHoursWithLateNight() * 3600 + moment().minute() * 60;
    timecard.end = timecard.working_hours[endIndex].end
}
function getCurrentHoursWithLateNight() {
    return moment().hour() <= 4 ? moment().hour() + 24 : moment().hour()

}

function createWorkingHour(workType) {
    if (workType == "出社") {
        return { ...newWorkingHour['office'] }
    } else if (workType == "在宅") {
        return { ...newWorkingHour['home'] }
    }
}
export async function saveTimecard(timecard, user) {
    copyOwnerToTimecard(timecard, user);
    timecard.id = getTimecardId(timecard.date_id, user.id)
    try {
        console.log(timecard)
        await db.collection("timecards").doc(timecard.id).set(timecard);
        return true;
    } catch (e) {
        console.error(e);
        return false
    }
}
export async function updateTimecard(timecard, user) {
    copyOwnerToTimecard(timecard, user);
    timecard.id = getTimecardId(timecard.date_id, user.id)
    try {
        console.log(timecard)
        await db.collection("timecards").doc(timecard.id).set(timecard, { merge: true });
        return true;
    } catch (e) {
        console.error(e);
        return false
    }
}
function getTimecardId(dateId, userId) {
    return userId + "-" + dateId
}
async function getTimecard(user, date) {
    const items = await db.collection("timecards")
        .where("owner_id", "==", user.id)
        .where("year", "==", date.year)
        .where("month", "==", date.month)
        .where("date", "==", date.date)
        .get()
    if (items.empty) {
        const timecard = timecardNew(user, date);
        timecard.lunch = 3600;
        timecard.break = 0;
        return timecard
    } else {
        return items.docs[0].data()
    }
}

export function timecardNew(user, date) {
    const item = {
        date_id: date.id,
        month_id: getMonthId(date.year, date.month),
        holidayType: "",
        start: null,
        end: null,
        lunch: 0,
        break: 0,
        break_late_night: 0,
        reasonsForEditStart: "",
        reasonsForEditEnd: "",
        isEditWorktime: false,
        costs: [],
        expenses: [],
        unixtime: moment(date.id).unix(),
        year: date.year,
        month: date.month,
        date: date.date,
        day_number: date.day_number,
        is_holiday: date.is_holiday,
        is_completed: false,
        working_hours: [],
        total_home_working_hours : 0,
        total_office_working_hours : 0,
        total_working_hours : 0,
        actual_home_working_hours: 0,
        actual_office_working_hours: 0,
        version: 2
    };
    if (user.commuting_allowance_type && user.commuting_allowance_type == "日額") {
        if (user.daily_commuting_allowance && user.daily_commuting_allowance > 0) {
            item.daily_commuting_allowance = user.daily_commuting_allowance;
        }
        if (
            user.daily_commuting_route &&
            user.daily_commuting_route.length > 0
        ) {
            item.daily_commuting_route = user.daily_commuting_route;
        }
    }
    return item;
}
function getMonthId(year, month) {
    return String(year) + "-" + ("0" + String(month)).slice(-2)
}
function copyOwnerToTimecard(timecard, user) {
    for (let k of Object.keys(keysOfOwnerToCopyToTimecard)) {
        timecard[k] = user[keysOfOwnerToCopyToTimecard[k]]
            ? user[keysOfOwnerToCopyToTimecard[k]]
            : "";
    }
}